import { useHasUserGroup } from "@/hooks/useHasUserGroup";
import { UserGroup } from "@/lib/userGroups";

// Mirrors the backend helper `IsVIPFromCtx` in
// `services/b3os-workflow/pkg/util/context/user_groups.go`, which treats admin
// as VIP for elevated-access checks.
const VIP_GROUPS = [UserGroup.VIP, UserGroup.Admin] as const;
export function useIsVip() {
  return useHasUserGroup(VIP_GROUPS);
}